import { ApplicationError } from '../shared/application-error';

export interface TermsAndConditionsModel {
    hasAcceptedTerms: boolean;
    hasAcceptedPrivacy: boolean;
    emailOptIn: boolean;
    termsAgreementId: string;
    policyAgreementId: string;
    userPreferenceEmailOptInId: string;
    applicationError: ApplicationError;
    hasError: boolean;
}
